import { extendTailwindMerge } from 'tailwind-merge'

export const twm = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-body-lg',
        'text-body-md',
        'text-body-md',
        'text-title-lg',
        'text-title-md',
        'text-title-md',
        'text-label-lg',
        'text-label-md',
        'text-label-md',
        'text-headline-lg',
        'text-headline-md',
        'text-headline-md'
      ]
    }
  }
})
